let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1xWiN")).then(() => parcelRequire('5LiKN'));